import { render, staticRenderFns } from "./AppBasicTable.vue?vue&type=template&id=ac618502&"
import script from "./AppBasicTable.vue?vue&type=script&lang=js&"
export * from "./AppBasicTable.vue?vue&type=script&lang=js&"
import style0 from "./AppBasicTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports